import React, {useEffect} from "react"
import qs from "qs"
import styled from "styled-components"
import {app, authentication} from "@microsoft/teams-js"
import {Button, InfoIcon, Tooltip} from "@fluentui/react-northstar"
import link from "services/bot-link"
import {useHistory} from "react-router-dom"
import createLink from "helpers/auth/createLink"
import {AUTH_END} from "App"
import {Header, Container, InfoText} from "../../components/ui"
import {NODE_ENV} from "utils/env"
import {PRODUCTION} from "../../utils/env/env";

interface Props {
}

export const LoginButtonWrapper = styled.div`
  width: 200px;
  height: 41px;
  display: flex;
  justify-content: center;
  margin-top: 3%;
`

const AuthStart: React.FC<Props> = () => {
  const history = useHistory()

  useEffect(() => {
    app.initialize().then(() => app.notifySuccess())
  }, [])

  const handleOnClick = () => {
    link.start().then((data) => {
      const redirect = `${window.location.href.split("#")[0]}#${AUTH_END}`
      const query = qs.stringify({redirect, state: data.state, useRedirectSso: true})
      const subdomain = data.subdomain ?? "app"
      const linkToAuthenticate = createLink(subdomain, query)
      console.log("Link to authenticate: ", linkToAuthenticate)
      authentication.authenticate({
        url: linkToAuthenticate,
      }).then(() => {
        history.replace("/create-recognition")
      }).catch((str) => {
        console.log("Authentication error: ", str)
        if (NODE_ENV !== PRODUCTION) {
          alert(str)
        }
      })
    })
  }

  return (
    <Container>
      <Header/>
      <InfoText>Please sign in to use Perkbox with Microsoft Teams</InfoText>
      <LoginButtonWrapper>
        <Button
          styles={{
            margin: "auto",
            width: "100%",
            height: "100%",
            border: "1px solid #8A8886",
            borderRadius: "0px"
          }}
          onClick={handleOnClick}>
          Sign in to Perkbox
        </Button>
      </LoginButtonWrapper>
      <InfoText
        style={{
          paddingTop: "1%",
          fontSize: "90%",
          display: "inline"
        }}>
        Trouble signing in via the app? <br/> Try again by accessing Microsoft Teams on your browser
        <Tooltip
          content={
            <div style={{fontSize: "90%"}}>
              If you’re having trouble signing in to your Perkbox account via the Microsoft Teams app, open Microsoft
              Teams on your browser, log in to Perkbox for Microsoft Teams over there and & return to the Teams app -
              you should now be logged in & good to go!
            </div>}
          trigger={<InfoIcon outline size={"small"} styles={{marginLeft: "5px"}}/>}
        />
      </InfoText>
    </Container>
  )
}

export default AuthStart
